export default function TopErrorMsg({ title }: { title: string }) {
  return (
    <div className="alert alert-error p-20 absolute top-0 z-20 ">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="stroke-white shrink-0 h-24 w-24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span className="text-6xl text-white">{title}</span>
    </div>
  );
}
